import React, { useState, useRef, useEffect } from "react";
import { Form, Input, Button, Space, Table, Menu, Image } from "antd";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import baseRequest from "../../utils/baseRequest";
import VideoPlayer from "../../components/VideoPlayer";
const ZonePostMachineReviewContent = (props) => {
  const { TextArea } = Input;
  const current = props.current;
  //表头
  const columns = [
    {
      title: "发帖人",
      dataIndex: "creator",
      key: "creator",
      render: (data) => (
        <div>
          <Image src={data.avatar.images[0].urls[0]} width={50} />
          <p>
            ID：<span className="text-red-400">{data.user_id}</span>
          </p>
          <p>
            昵称：<span className="text-red-400">{data.name}</span>
          </p>
        </div>
      ),
    },
    {
      title: "动态内容",
      dataIndex: "content",
      key: "content",
      width: 500,
      render: (data) => (
        <div className="flex flex-col">
          <div>
            <p className="text-red-400">
              文案：<span className="text-black">{data.text}</span>
            </p>
            {data.is_creating_paid_text === 1 && (
              <p className="text-red-400">
                付费文案：<span className="text-black">{data.paid_text}</span>
              </p>
            )}
          </div>
          <p className="text-red-400">媒体：</p>
          <div
            className={`grid ${
              (data.media?.images[0]?.h <= data.media?.images[0]?.w &&
                data.media?.images.length < 4) ||
              data.media?.images.length === 0
                ? "grid-cols-2"
                : "grid-cols-4"
            } gap-2`}
          >
            <Image.PreviewGroup
              items={data.media.images?.map((item) => item.urls[0])}
            >
              {data.media.images.map((item, index) => (
                <div className="self-start" key={index}>
                  <Image src={item.urls[0]} />
                </div>
              ))}
            </Image.PreviewGroup>
            {data.media.videos.map((item, index) => (
              <div className="self-start" key={index}>
                <VideoPlayer url={item.urls[0]} width={150} />
              </div>
            ))}
          </div>
        </div>
      ),
    },
    {
      title: "付费设置",
      dataIndex: "paymentSettings",
      key: "paymentSettings",
      render: (data) => (
        <div className="flex flex-col">
          <p className="text-red-400">
            类型：
            <span className="text-black">
              {data.c_type === 0 ? "免费" : "付费"}
            </span>
          </p>
          {data.c_type === 1 && (
            <div>
              <hr />
              <p className="text-red-400">
                价格：
                <span className="text-black">¥{data.price}</span>
              </p>
              <hr />
              <p className="text-red-400">
                是否铁粉免费看：
                <span className="text-black">
                  {data.is_ironfan_visible === 0 ? "否" : "是"}
                </span>
              </p>
              <hr />
              <p className="text-red-400">
                文案可见行数：
                <span className="text-black">{data.text_visible_range}</span>
              </p>
              {data.m_type === 1 ? (
                <>
                  <hr />
                  <p className="text-red-400">
                    图片可见张数：
                    <span className="text-black">
                      {data.media_visible_range}
                    </span>
                  </p>
                </>
              ) : (
                <>
                  <hr />
                  <p className="text-red-400">
                    是否模糊封面：
                    <span className="text-black">
                      {data.is_blurring_cover === 0 ? "否" : "是"}
                    </span>
                  </p>
                </>
              )}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "审核结果",
      dataIndex: "info",
      key: "info",
      render: (data) => (
        <div className="flex flex-col">
          <p>文案审核结果：</p>
          <p className="text-green-400">{data.text_audit_opinion}</p>
          <hr className="w-full" />
          <p>媒体审核结果：</p>
          <p className="text-green-400">{data.image_audit_opinion}</p>
        </div>
      ),
    },
    {
      title: "发布时间",
      dataIndex: "submitTime",
      key: "submitTime",
    },
    {
      title: "备注",
      dataIndex: "remarks",
      key: "remarks",
      render: (_, record) => (
        <div className="flex flex-col">
          <Form.Item
            name={record.momentId}
            initialValue={record.remarks.manually_review_opinion}
          >
            <TextArea rows={4} disabled={current != "operatorReviewing"} />
          </Form.Item>
        </div>
      ),
    },
    {
      title: "操作",
      dataIndex: "opeartion",
      key: "opeartion",
      render: (_, record) => (
        <div>
          <Space>
            {current === "operatorReviewing" && (
              <Space.Compact direction="vertical">
                <Button type="primary" onClick={() => onClickPass(record)}>
                  通过
                </Button>
                <Button onClick={() => onClickReject(record)}>拒绝</Button>
              </Space.Compact>
            )}
          </Space>
        </div>
      ),
    },
  ];
  //给表单绑定ref
  const formRef = useRef(null);
  //点击通过按钮
  const onClickPass = (record) => {
    formRef.current.record = record;
    formRef.current.type = 0;
    formRef.current.submit();
  };
  //点击拒绝按钮
  const onClickReject = (record) => {
    formRef.current.record = record;
    formRef.current.type = 1;
    formRef.current.submit();
  };
  //提交表单
  const handleSubmit = async (value) => {
    try {
      const base = baseRequest();
      const response = await fetch("/op/zone_moment/review", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          zone_moment_ids: [parseInt(formRef.current.record.momentId, 10)],
          op_type: formRef.current.type,
          manually_review_opinion: value[formRef.current.record.momentId]
            ? value[formRef.current.record.momentId]
            : "",
          ...base,
        }),
      });
      const _data = await response.json();
      if (_data.ret === -1) {
        alert(_data.msg);
        return;
      }
      //取消数据展示
      setShowData(
        showData.filter(
          (item) => item.momentId !== formRef.current.record.momentId
        )
      );
    } catch (error) {
      console.error(error);
    }
  };
  //获取数据
  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [more, setMore] = useState(1);
  const getData = async () => {
    if (!more) return;
    let querryStatus;
    switch (current) {
      case "operatorReviewing":
        querryStatus = 1;
        break;
      case "machineReviewing":
        querryStatus = 0;
        break;
      case "onlySelfCanSee":
        querryStatus = 3;
        break;
      default:
        break;
    }
    try {
      const base = baseRequest();
      const response = await fetch("/op/zone_moment/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          status: querryStatus,
          offset: offset,
          limit: 200,
          ...base,
        }),
      });
      const temData = await response.json();
      console.log(temData);
      if (temData.ret === -1) {
        alert(temData.msg);
        return;
      }
      //匹配表格格式
      const structedData = temData.data.list.map((item, index) => {
        return {
          key: index,
          momentId: item.id,
          creator: item.streamer_ext,
          content: {
            media: item.media_component,
            text: item.paid_text
              ? item.text.slice(0, item.text.length - item.paid_text.length)
              : item.text,
            paid_text: item.paid_text
              ? item.paid_text.substring(1)
              : item.paid_text,
            is_creating_paid_text: item.is_creating_paid_text,
          },
          paymentSettings: {
            c_type: item.c_type,
            m_type: item.m_type,
            price: item.price / 100,
            is_ironfan_visible: item.is_ironfan_visible,
            text_visible_range: item.text_visible_range,
            media_visible_range: item.media_visible_range,
            is_blurring_cover: item.is_blurring_cover,
          },
          info: {
            image_audit_status: item.image_audit_status,
            image_audit_opinion: item.image_audit_opinion,
            text_audit_status: item.text_audit_status,
            text_audit_opinion: item.text_audit_opinion,
          },
          submitTime: new Date(item.ct * 1000).toLocaleString(),
          remarks: {
            manually_review_status: item.manually_review_status,
            manually_review_opinion: item.manually_review_opinion,
            manually_review_operator: item.manually_review_operator,
          },
        };
      });
      setData([...data, ...structedData]);
      setOffset(temData.data.offset);
      setMore(temData.data.more);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getData();
  }, [current]);

  //展示的数据
  const [showData, setShowData] = useState([]);
  useEffect(() => {
    setShowData(data);
  }, [data]);
  //表单提交失败
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <p>
        {current === "operatorReviewing" && `运营待审核${showData.length}条`}
        {current === "onlySelfCanSee" && `审核未通过${showData.length}条`}
      </p>
      <Form
        ref={formRef}
        name="remarks"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
      >
        <Table
          columns={columns}
          dataSource={showData}
          pagination={{ pageSize: 20 }}
          scroll={{ y: window.innerHeight - 300 }}
        />
      </Form>
    </div>
  );
};

export default function ZonePostMachineReview() {
  const navigate = useNavigate();
  //当前tab
  const location = useLocation();
  const pathname = location.pathname.split("/")[2] || "operatorReviewing";
  const [current, setCurrent] = useState(pathname);
  //tab名称
  const items = [
    {
      label: "运营待审核",
      key: "operatorReviewing",
    },
    {
      label: "机审中",
      key: "machineReviewing",
    },
    {
      label: "审核未通过",
      key: "onlySelfCanSee",
    },
  ];
  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
    window.location.reload();
  };

  return (
    <div>
      <Menu
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={items}
      />
      <Routes>
        <Route
          path="/"
          element={<Navigate to="/zonePostMachineReview/operatorReviewing" />}
        />
        <Route
          path="/operatorReviewing"
          element={<ZonePostMachineReviewContent current="operatorReviewing" />}
        />
        <Route
          path="/machineReviewing"
          element={<ZonePostMachineReviewContent current="machineReviewing" />}
        />
        <Route
          path="/onlySelfCanSee"
          element={<ZonePostMachineReviewContent current="onlySelfCanSee" />}
        />
      </Routes>
    </div>
  );
}
